<template>
  <div class="order-summary">
    <v-row class="mb-4">
      <v-col>
        <span>
          Order Summary
        </span>
      </v-col>
    </v-row>

    <v-row v-for="(part, i) in orderItems" :key="i">
      <v-col>
        <span>
          {{ `${part.clientPartNo} (${part.quantity || 0} PCS @
          ${ formatCurrency(getItemPrice(part)) })` }}
        </span>
      </v-col>

      <v-col class="d-flex justify-end">
        <span>
          {{ formatCurrency(getItemPrice(part) * (part.quantity || 0)) }}
        </span>
      </v-col>
    </v-row>

    <v-row class="mt-8">
      <v-col>
        <span>
          Estimated tax
        </span>
      </v-col>

      <v-col class="d-flex justify-end">
        <span>
          ---
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <span>
          Shipping & service
        </span>
      </v-col>

      <v-col class="d-flex justify-end">
        <span>
          {{ formatCurrency(450) }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <span class="title">
          Estimated total
        </span>
      </v-col>

      <v-col class="d-flex justify-end">
        <span class="title">
          {{ formatCurrency(orderTotal) }}
        </span>
      </v-col>
    </v-row>

    <v-row class="my-8">
      <v-col>
        <div>
          <div class="font-weight-light">
            When you place your order, you're agreeing to a few things;
          </div>
          <br>
          <div class="font-weight-light">
            The <a href="#">Terms of Service</a> for Komaspec and Purchases on Komacut.
          </div>
          <br>
          <div class="font-weight-light">
            That your Komacut Payments info (includes your stored credit card or banking
            information data, billing addresses, and phone numbers)
            can be accessed and used as described by the
            <a href="#">Komaspec Privacy Notice.</a>
          </div>
          <br>
          <div class="font-weight-light">
            Your Payments info and personal info
            (includes your name, email, address, and contact info),
            along with your orders, may also be used as described by our
            <a href="#">Privacy Policy</a>,
            and shared with some third-parties,
            delivery personnel, and vendors in order to
            fulfill your order, and for analytics.
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          color="black"
          class="mt-4 white--text"
          depressed
          @click="submitOrder"
        >
          Place Order
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CurrencyFormatterMixin from '../../../../mixins/currencyFormatter';

export default {
  name: 'Summary',

  mixins: [
    CurrencyFormatterMixin,
  ],

  props: {
    orderItems: Array,
  },

  computed: {
    orderTotal() {
      const placeholderTax = 450;

      // 450 default value is the service and tax given in the demo screens
      const total = _.reduce(
        _.filter(this.orderItems, oi => oi.quantity !== undefined && oi.quantity !== 0),
        (sum, part) => sum + (this.getItemPrice(part) * part.quantity), placeholderTax
      );
      return Math.round((total + Number.EPSILON) * 100) / 100;
    },
  },

  methods: {
    submitOrder() {
      this.$emit('submit', this.orderTotal);
    },

    getItemPrice(item) {
      const sortedByPrice = _.sortBy(item.pricing, p => p.minQuantity);
      const itemPrice = _.find(sortedByPrice, p => p.minQuantity >= item.quantity);
      if (itemPrice) {
        return itemPrice.price;
      }
      return item.quantity ? _.last(sortedByPrice).price : 0;
    },
  },
};
</script>

<style scoped>

</style>
